import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ROUTES } from "@/config/routes";
import { cn } from "@/utils/cn";

interface CategoriesDropDownProps {
  categories?: { id: number; name: string }[];
}

const HeaderDropDown = ({ categories }: CategoriesDropDownProps) => {
  const { t } = useTranslation();

  return (
    <Menu>
      <MenuButton
        className={"header-link relative py-4 text-sm/4 font-semibold uppercase text-white hover:text-primary"}
      >
        {t("General.more")}
      </MenuButton>
      <MenuItems
        modal={false}
        transition
        anchor="bottom end"
        className={"z-[100] mt-2 w-[210px] overflow-hidden rounded-xl bg-surface-bright"}
      >
        {categories &&
          categories.slice(3).map((category) => (
            <MenuItem key={category.id}>
              <Link
                to={ROUTES.MAIN.CATALOG.replace(":id", category.id.toString())}
                aria-label={category.name}
                className={cn(
                  "header-link relative block px-4 py-3 text-[1rem] font-medium  transition-colors hover:bg-surface-container-high",
                )}
              >
                {category.name}
              </Link>
            </MenuItem>
          ))}
      </MenuItems>
    </Menu>
  );
};

export default HeaderDropDown;
